import React from 'react';
import {loadStripe} from '@stripe/stripe-js';


const UserPayment = () => {
    return (
        <div>
            
        </div>
    );
};

export default UserPayment;